import React, { useState } from 'react';
import { Form, Button, Upload, message, Typography, Row, Col, Card, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import Post from '../services/Post';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const VideoUploadPage = () => {
    const [isFileValid, setIsFileValid] = useState(true);
    const [processing, setProcessing] = useState(false);

    const navigate = useNavigate();
    const [form] = Form.useForm();

    const handleSubmit = async (values) => {
        const file = values.video; // Retrieve the file from the form state

        if (!file) {
            message.error("Please select a video to upload");
            return;
        }

        console.log('file', file);
        setProcessing(true);

        try {
            // Call the upload function with the selected file
            await handleVideoUpload(file); // `originFileObj` contains the actual File object
        } catch (error) {
            console.error("Video upload failed:", error);
            message.error("Failed to upload the video. Please try again.");
        } finally {
            setProcessing(false);
        }
    };

    const handleVideoUpload = async (file) => {
        console.log('handle function', file);

        const user = JSON.parse(localStorage.getItem('user')); // Get user data
        if (!user) {
            console.error("User not logged in");
            message.error("User not logged in");
            return;
        }

        try {
            const response = await Post.UploadVideo({
                video: file, // Pass the video file object here
                id: user.id, // Pass the user's ID here
            });
            console.log("Upload successful:", response);
            message.success("Upload successful");
            navigate('/user/upload-success');
        } catch (error) {
            message.error(error.message);
        }
    };

    return (
        <div className="custom-row" style={{ marginBottom: '50px' }}>
            <div className="container-xxl py-5">
                <div className="container py-5 px-lg-5">
                    <div>
                        <Title level={1} style={{ textAlign: 'center', marginBottom: '20px' }}>
                            Upload Your Video for Nasha Mukti Shapath <br /> नशा मुक्ति शपथ के लिए अपनी वीडियो अपलोड करें
                        </Title>
                        <Paragraph style={{ textAlign: 'center', marginBottom: '40px' }}>
                            नशा मुक्ति शपथ के लिए अपनी वीडियो अपलोड करें और हमारे अभियान से जुड़ें / Upload your video for
                            Nasha Mukti Shapath and join our mission
                        </Paragraph>
                    </div>
                    <Row justify="center" align="middle">
                        <Col md={12}>
                            <Card>
                                <Form id="video-form" layout="vertical" onFinish={handleSubmit} form={form}>
                                    <Form.Item
                                        label="Upload Video"
                                        name="video"
                                        rules={[{ required: true, message: 'Please upload a video!' }]}
                                    >
                                        <Upload.Dragger
                                            beforeUpload={() => false} // Prevent automatic upload
                                            className="custom-dragger"
                                            accept="video/*"
                                            multiple={false} // Allow only one file
                                            onChange={({ file }) => {
                                                // Manually set the file into the form
                                                if (file) {
                                                    form.setFieldsValue({ video: file });
                                                }
                                            }}
                                        >
                                            <p className="ant-upload-drag-icon">
                                                <UploadOutlined />
                                            </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                            <p className="ant-upload-hint">Support for a single video file. Upload a video file smaller than 10 MB.</p>
                                        </Upload.Dragger>
                                    </Form.Item>
                                    <Row justify="center">
                                        <Col>
                                            <Form.Item>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    style={{
                                                        backgroundColor: '#a6cc43',
                                                        borderColor: '#a6cc43',
                                                        color: '#FFFFFF',
                                                    }}
                                                    disabled={processing}
                                                >
                                                    {processing ? <Spin size='small' /> : "Submit"}
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default VideoUploadPage;
